module.exports = __webpack_public_path__ + "img/public/SiteIcons/noMessageIcon.svg?7fcb97f6";